module.exports = __webpack_public_path__ + "img/4.da42c3fd.png";